import { render, staticRenderFns } from "./messageCard.vue?vue&type=template&id=50b59303&"
import script from "./messageCard.vue?vue&type=script&lang=js&"
export * from "./messageCard.vue?vue&type=script&lang=js&"
import style0 from "./messageCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports